import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { FamilyStudent } from "../../models/family-student.model";
import { StudentScholarshipData } from "src/app/modules/scholarship/models/student-scholarship-data.model";
import { StudentData } from "src/app/modules/student/models/student-data.model";
import { Family } from "../../models/family-response.model";
import { StudentForm } from "src/app/modules/student/models/student-form";
import { StudentEngagementData } from "src/app/modules/engagement/models/engagement-student.model";
import { FamilyAddForm } from "../../models/family-form-add.model";
import { FormGroup } from "@angular/forms";
import { FamilyValidateDupDNIAccount } from "../../models/family-response-validateduplicated-dniaccount.model";
import { DuplicatedDNIAccountBank } from "../../models/family-request-dniaccountbank.model";
import { UpdateFamilyData } from "../../models/family-data.model";

export namespace FamilyActions {
  @logDispatcher
  export class GetFamilyStudent {
    static readonly type = '[Family] GetFamilyStudent';
    constructor(public familyId: number, public exerciseId: number) {}
  }

  @logDispatcher
  export class GetFamilyStudentSuccess {
    static readonly type = '[Family] GetFamilyStudentSuccess';
    constructor(
      public familyStudent: FamilyStudent,
      public exerciseId: number
    ) {}
  }

  @logDispatcher
  export class GetIsDuplicatedDNIBank {
    static readonly type = '[Family] GetIsDuplicatedDNIBank';
    constructor(public duplicatedDNIBankAccount: DuplicatedDNIAccountBank) {}
  }

  @logDispatcher
  export class GetIsDuplicatedDNIBankSuccess {
    static readonly type = '[Family] GetIsDuplicatedDNIBankSuccess';
    constructor(public isDuplicated: FamilyValidateDupDNIAccount) {}
  }

    @logDispatcher
    export class GetFamilies {
      static readonly type = '[Family] GetFamilies';
      constructor() {}
    }

  @logDispatcher
  export class GetFamiliesSuccess {
    static readonly type = '[Family] GetFamiliesSuccess';
    constructor(public families: Family[]) {}
  }

  @logDispatcher
    export class RefreshFamilies {
      static readonly type = '[Family] RefreshFamilies';
      constructor() {}
    }

  @logDispatcher
  export class EditFamily {
    static readonly type = '[Family] EditFamily';
    constructor(public user: string, public familyDetailForm: FormGroup) {}
  }

  @logDispatcher
  export class EditFamilySuccess {
    static readonly type = '[Family] EditFamilySuccess';
    constructor(public updateFamilyData: UpdateFamilyData) {}
  }

  @logDispatcher
  export class AddStudentToFamily {
    static readonly type = '[Family] AddStudentToFamily';
    constructor(public studentData: StudentData) {}
  }

  @logDispatcher
  export class UpdateStudentOnFamily {
    static readonly type = '[Family] AddStudentToFamily';
    constructor(public studentData: StudentForm) {}
  }

  @logDispatcher
  export class DeleteFamily {
    static readonly type = '[Family] DeleteFamily';
    constructor(public familyId: number, public user: string) {}
  }

  @logDispatcher
  export class DeleteFamilySuccess {
    static readonly type = '[Family] DeleteFamilySuccess';
    constructor() {}
  }

  @logDispatcher
  export class DeleteStudentOnFamily {
    static readonly type = '[Family] DeleteStudentOnFamily';
    constructor(public studentId: number) {}
  }

  @logDispatcher
  export class AddFamily {
    static readonly type = "[Family] AddFamily"
    constructor(public family: FamilyAddForm, public user: string) {}
  }

  @logDispatcher
  export class AddFamilySuccess {
    static readonly type = '[Family] AddFamilySuccess';
    constructor(public newFamilyId: number) {}
  }

  @logDispatcher
  export class AddStudentScholarship {
    static readonly type = '[Family] AddStudentScholarship';
    constructor(public studentScholarshipData: StudentScholarshipData) {}
  }

  @logDispatcher
  export class DeleteStudentScholarship {
    static readonly type = '[Family] DeleteStudentScholarship';
    constructor(
      public studentId: number,
      public studentScholarshipId: number
    ) {}
  }

  @logDispatcher
  export class AddStudentEngagement {
    static readonly type = '[Family] AddStudentEngagement';
    constructor(public studentEngagementData: StudentEngagementData) {}
  }

  @logDispatcher
  export class DeleteStudentEngagement {
    static readonly type = '[Family] DeleteStudentEngagement';
    constructor(public engagementId: number, public studentId: number) {}
  }


  @logDispatcher
  export class SetFilterCurrentExercise {
    static readonly type = '[Family] SetFilterCurrentExercise';
    constructor(public exerciseId: number) {}
  }

  @logDispatcher
  export class SetIsListSmaller {
    static readonly type = '[Family] SetIsListSmaller';
    constructor(public isListSmaller: boolean) {}
  }

  @logDispatcher
  export class SetBankAccount1Form {
    static readonly type = '[Family] SetBankAccount1Form';
    constructor(public bankAccount1: string) {}
  }

  @logDispatcher
  export class SetBankAccount1AddForm {
    static readonly type = '[Family] SetBankAccount1AddForm';
    constructor(public bankAccount1: string) {}
  }

  @logDispatcher
  export class SetStudentDiet {
    static readonly type = '[Family] SetStudentDiet';
    constructor(public dietId: number, public studentId: number, public value: boolean) {}
  }

  @logDispatcher
  export class SetFamilyAddDefaultState {
    static readonly type = '[Family] SetFamilyAddDefaultState';
    constructor() {}
  }

  @logDispatcher
  export class SetFamilyFormDefaultState {
    static readonly type = '[Family] SetFamilyFormDefaultState';
    constructor() {}
  }

  @logDispatcher
  export class SetFamilyDefaults {
    static readonly type = '[Family] SetFamilyDefaults';
    constructor() {}
  }

  @logDispatcher
  export class SetIsSubmitted {
    static readonly type = '[Family] SetIsSubmitted';
    constructor(public isSubmitted: boolean) {}
  }

  @logDispatcher
  export class SetIsEdited {
    static readonly type = '[Family] SetIsEdited';
    constructor(public isEdited: boolean) {}
  }

  @logDispatcher
  export class Error {
    static readonly type = '[Family] Error';
    constructor(public error: any) {}
  }
}
